module.exports = __webpack_public_path__ + "img/p001.b4f77dc6.png";